/**
 * Customer-facing copy for contract rewards that the legacy `PromotionReward`
 * label logic can't express. Pure: callers inject name lookups, price
 * formatting and the i18n templates.
 */
import type { CategoryBundle, CategoryBundleGroup } from "@/lib/promotion-engine";

export type BundleDescribeDeps = {
  categoryName: (id: string) => string | undefined;
  itemName: (id: string) => string | undefined;
  formatPrice: (amount: number) => string;
  /** "Any {{name}}" */
  any: (name: string) => string;
  /** "{{groups}} for {{price}}" */
  forPrice: (groups: string, price: string) => string;
};

function groupLabel(g: CategoryBundleGroup, d: BundleDescribeDeps): string {
  const names = [
    ...(g.categoryIds ?? []).map((id) => d.any(d.categoryName(id) ?? id)),
    ...(g.itemIds ?? []).map((id) => d.itemName(id) ?? id),
  ];
  const label = names.join(" / ");
  const q = g.quantity ?? 1;
  return q > 1 ? `${q}× ${label}` : label;
}

/** e.g. "Any Dessert + Any Drink for EGP 250". */
export function describeCategoryBundle(r: CategoryBundle, d: BundleDescribeDeps): string {
  const groups = r.groups.map((g) => groupLabel(g, d)).join(" + ");
  return d.forPrice(groups, d.formatPrice(r.bundlePrice));
}
